import { Checkbox, Paper, Stack, TextInput } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import { IconFolder } from '@tabler/icons-react'
import { FormattedMessage, useIntl } from 'react-intl'
import { PlatformAlert } from '@/components/ui-shared/PlatformAlert/PlatformAlert'
import { InputSourceFormValues } from './types'

type MediaFolderFormProps = {
  form: UseFormReturnType<InputSourceFormValues>
}

export const MediaFolderForm = ({ form }: MediaFolderFormProps) => {
  const intl = useIntl()

  return (
    <Stack gap="lg">
      <PlatformAlert variant="info">
        <FormattedMessage id="deployments.mediaFolder.description" />
      </PlatformAlert>

      <PlatformAlert variant="warning">
        <FormattedMessage id="deployments.mediaFolder.deviceSupport.info" />
      </PlatformAlert>

      <Paper bg="gray.1" p="xl">
        <Stack gap="xl">
          <TextInput
            size="md"
            {...form.getInputProps('mediaFolderConfig.input_folder_path')}
            label={
              <FormattedMessage id="deployments.mediaFolder.inputFolder.label" />
            }
            description={
              <FormattedMessage id="deployments.mediaFolder.inputFolder.description" />
            }
            placeholder={intl.formatMessage({
              id: 'deployments.mediaFolder.inputFolder.placeholder'
            })}
            leftSection={<IconFolder size={20} />}
            inputWrapperOrder={['label', 'input', 'description', 'error']}
          />

          <TextInput
            size="md"
            {...form.getInputProps('mediaFolderConfig.output_folder_path')}
            label={
              <FormattedMessage id="deployments.mediaFolder.outputFolder.label" />
            }
            description={
              <FormattedMessage id="deployments.mediaFolder.outputFolder.description" />
            }
            placeholder={intl.formatMessage({
              id: 'deployments.mediaFolder.outputFolder.placeholder'
            })}
            leftSection={<IconFolder size={20} />}
            inputWrapperOrder={['label', 'input', 'description', 'error']}
          />

          <Checkbox
            size="sm"
            {...form.getInputProps('mediaFolderConfig.delete_processed', {
              type: 'checkbox'
            })}
            label={
              <FormattedMessage id="deployments.mediaFolder.deleteProcessedFiles.label" />
            }
            description={
              <FormattedMessage id="deployments.mediaFolder.deleteProcessedFiles.description" />
            }
          />
        </Stack>
      </Paper>
    </Stack>
  )
}
